import { render, staticRenderFns } from "./Lgx243089970070290432.vue?vue&type=template&id=c2f3c646&scoped=true&"
import script from "./Lgx243089970070290432.vue?vue&type=script&lang=js&"
export * from "./Lgx243089970070290432.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243089970070290432.vue?vue&type=style&index=0&id=c2f3c646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f3c646",
  null
  
)

export default component.exports